// Temporary compatibility for saved CRUD links. Keep navigation on named routes.
export const legacyCrudTargets = [
  ['/accounts/new', 'accountCreate'],
  ['/accounts/update/:accountId', 'accountUpdate'],
  ['/accounts/detail/:accountId', 'accountDetail'],
  ['/accounts/:accountId/collaborator/new', 'collaboratorCreate'],
  ['/accounts/:accountId/collaborator/update/:collaboratorId', 'collaboratorUpdate'],
  ['/roles/new', 'roleCreate'],
  ['/roles/update/:roleId', 'roleUpdate'],
  ['/profile/collaborator/:collaboratorId', 'profileCollaborator'],
  ['/stores/new', 'storeCreate'],
  ['/stores/update/:storeId', 'storeUpdate'],
  ['/stores/detail/:storeId', 'storeDetail'],
  ['/distributor-networks/new', 'distributorNetworkCreate'],
  ['/distributor-networks/update/:networkId', 'distributorNetworkUpdate'],
  ['/distributor-networks/detail/:networkId', 'distributorNetworkDetail'],
  ['/distributor-groups/new', 'distributorGroupCreate'],
  ['/distributor-groups/update/:groupId', 'distributorGroupUpdate'],
  ['/distributor-groups/detail/:groupId', 'distributorGroupDetail'],
  ['/key-account-networks/new', 'keyAccountNetworkCreate'],
  ['/key-account-networks/update/:networkId', 'keyAccountNetworkUpdate'],
  ['/key-account-networks/detail/:networkId', 'keyAccountNetworkDetail'],
  ['/key-account-groups/new', 'keyAccountGroupCreate'],
  ['/key-account-groups/update/:groupId', 'keyAccountGroupUpdate'],
  ['/key-account-groups/detail/:groupId', 'keyAccountGroupDetail'],
  ['/operating-centers/new', 'operatingCenterCreate'],
  ['/operating-centers/update/:operatingCenterId', 'operatingCenterUpdate'],
  ['/operating-centers/detail/:operatingCenterId', 'operatingCenterDetail'],
  ['/billing/new', 'billingCreate'],
  ['/billing/update/:billingId', 'billingUpdate'],
  ['/billing/detail/:billingId', 'billingDetail'],
  ['/products/new', 'productCreate'],
  ['/products/update/:productId', 'productUpdate'],
  ['/products/detail/:productId', 'productDetail'],
  ['/products/breakdown/new/:productId', 'productBreakdownCreate'],
  ['/products/:productId/breakdown/update/:productBreakdownId', 'productBreakdownUpdate'],
  ['/local-brands/new/:storeId', 'localBrandManufacturerCreate'],
  ['/manufacturers/new', 'manufacturerCreate'],
  ['/manufacturers/update/:manufacturerId', 'manufacturerUpdate'],
  ['/manufacturers/detail/:manufacturerId', 'manufacturerDetail'],
  ['/categories/new', 'categoryCreate'],
  ['/categories/update/:categoryId', 'categoryUpdate'],
  ['/categories/detail/:categoryId', 'categoryDetail'],
  ['/sub-categories/new', 'subCategoryCreate'],
  ['/sub-categories/update/:subCategoryId', 'subCategoryUpdate'],
  ['/sub-categories/detail/:subCategoryId', 'subCategoryDetail'],
  ['/serial-number-model/new/:subCategoryId', 'modelSerialNumberCreate'],
  ['/serial-number-model/update/:subCategoryId/:modelSerialNumberId', 'modelSerialNumberUpdate'],
  ['/guarantees/new', 'guaranteeCreate'],
  ['/guarantees/update/:guaranteeId', 'guaranteeUpdate'],
  ['/region-codes/new', 'regionCodeCreate'],
  ['/region-codes/update/:regionCodeId', 'regionCodeUpdate'],
  ['/repairers/new', 'repairerCreate'],
  ['/repairers/update/:repairerId', 'repairerUpdate'],
  ['/repairers/detail/:repairerId', 'repairerDetail'],
  ['/repairers/:repairerId/repair-center/new', 'repairCenterCreate'],
  ['/repair-centers/detail/:repairCenterId', 'repairCenterDetail'],
  ['/repair-centers/update/:repairCenterId', 'repairCenterUpdate'],
  ['/repair-centers/:repairCenterId/repair-center-link/new', 'repairCenterLinkCreate'],
  ['/repair-centers-link/detail/:repairCenterLinkId', 'repairCenterLinkDetail'],
  ['/repair-centers-link/update/:repairCenterLinkId', 'repairCenterLinkUpdate'],
  ['/transporter/expressist/new', 'expressistCreate'],
  ['/transporter/expressist/update/:expressistId', 'expressistUpdate'],
  ['/transporter/expressist/detail/:expressistId', 'expressistDetail'],
  ['/transporter/expressist/connexion/create/:expressistId', 'expressistConnexionCreate'],
  ['/transporter/expressist/connexion/update/:expressistConnexionId', 'expressistConnexionUpdate'],
  ['/transporter/expressist/connexion/detail/:expressistConnexionId', 'expressistConnexionDetail'],
  ['/transporter/expressist/connexion/link/new/:expressistConnexionId', 'expressistLinkCreate'],
  ['/recycling-module', 'recyclingModule'],
  ['/recycling-module/recycler/new', 'recyclerCreate'],
  ['/recycling-module/recycler/detail/:recyclerId', 'recyclerDetail'],
  ['/recycling-module/recycler/update/:recyclerId', 'recyclerUpdate'],
  ['/recycling-module/recycler-center/new/:recyclerId', 'recyclerCenterCreate'],
  ['/recycling-module/recycler-center/detail/:recyclerCenterId', 'recyclerCenterDetail'],
  ['/recycling-module/recycler-center/update/:recyclerCenterId', 'recyclerCenterUpdate'],
  ['/recycling-module/recycler-center-link/new/:recyclerCenterId', 'recyclerCenterLinkCreate'],
  [
    '/recycling-module/recycler-center-link/detail/:recyclerCenterLinkId',
    'recyclerCenterLinkDetail'
  ],
  [
    '/recycling-module/recycler-center-link/update/:recyclerCenterLinkId',
    'recyclerCenterLinkUpdate'
  ],
  ['/recycling-module/reconditioner/new', 'reconditionerCreate'],
  ['/recycling-module/reconditioner/detail/:reconditionerId', 'reconditionerDetail'],
  ['/recycling-module/reconditioner/update/:reconditionerId', 'reconditionerUpdate'],
  ['/recycling-module/reconditioner-center/new/:reconditionerId', 'reconditionerCenterCreate'],
  [
    '/recycling-module/reconditioner-center/detail/:reconditionerCenterId',
    'reconditionerCenterDetail'
  ],
  [
    '/recycling-module/reconditioner-center/update/:reconditionerCenterId',
    'reconditionerCenterUpdate'
  ],
  [
    '/recycling-module/reconditioner-center-link/new/:reconditionerCenterId',
    'reconditionerCenterLinkCreate'
  ],
  [
    '/recycling-module/reconditioner-center-link/detail/:reconditionerCenterLinkId',
    'reconditionerCenterLinkDetail'
  ],
  [
    '/recycling-module/reconditioner-center-link/update/:reconditionerCenterLinkId',
    'reconditionerCenterLinkUpdate'
  ]
]

export default legacyCrudTargets.map(([path, name]) => ({
  path,
  redirect: (to) => ({ name, params: to.params, query: to.query, hash: to.hash })
}))
